import Component from './component'
import { types as t, getSnapshot, Instance } from '@invisr/mobx-state-tree'
import type { IObservableArray } from 'mobx'
import crudActions from './crud-actions'
import Auditable from './auditable'
import ref from './reference'
import { matchPath } from 'react-router'
import { v4 as uuid } from 'uuid'

const urlPattern = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/

const RouteItem = t
  .model('RouteItem', {
    icon: t.maybeNull(t.string),
    route: t.maybeNull(t.string),
    parentRoute: t.maybeNull(t.string),
    label: t.maybeNull(t.string),
    title: t.maybeNull(t.string),
    page: ref(Component, 'pages'),
    hideInMenu: t.maybeNull(t.boolean),
    inDevelopment: t.maybeNull(t.boolean)
  })
  .volatile(self => ({
    volatileId: uuid()
  }))
  .views(self => ({
    get href () {
      return self.route
    },
    get cleanPath () {
      let path: string = (self as any).href || self.label
      if (path.substring(0, 1) !== '/') path = '/' + path
      return path
    },
    get isExternalRoute () {
      return self.route && self.route.match(urlPattern) != null
    },
    matchesPath (path, exact = false, strict = false) {
      let match = matchPath(path, { path: self.route, exact, strict })
      return match
    }
  }))
  .actions(crudActions)
export const Navigation = t
  .model('Navigation', {
    id: t.identifier,
    name: t.string,
    routes: t.maybeNull(t.array(RouteItem))
  })
  .actions(self => {
    function addRoute (r) {
      self.routes.push(r || {})
    }
    function cloneRoutes (rs, store, device, clonePages = false) {
      const routesToAdd = rs.filter(sourceRoute => {
        const exist = self.routes.find(destinationRoute => destinationRoute.route === sourceRoute.route)
        return !exist
      })
      routesToAdd.map(r => {
        let newlyCreated
        if (clonePages) {
          const newPage = r.page.getSnapshotWithNewIds()
          newPage.name = newPage.name.concat(` - ${device}`)
          newlyCreated = store.newComponent('pages', newPage)
        }
        let newRoute = getSnapshot<Instance<typeof RouteItem>>(r)
        newRoute = { ...newRoute, page: newlyCreated ? newlyCreated.id : r.page.id }
        self.routes.push(newRoute)
      })
    }
    function update (key, val) {
      self[key] = val
    }
    function updateItem (item) {
      Object.keys(item).map(k => {
        self[k] = item[k]
      })
    }
    function afterCreate () {
      self.routes = self.routes || ([] as IObservableArray)
    }
    return {
      addRoute,
      cloneRoutes,
      update,
      updateItem,
      afterCreate
    }
  })
  .actions(crudActions)

export default t.compose(
  'NavigationItem',
  Navigation,
  Auditable
)
